import { UserAccountRole } from "./account/UserAccountRole";
import { UserEmail } from "./UserEmail";
import { UserId } from "./UserId";
import { UserName } from "./UserName";

const UserType = Symbol();

export class User {
    [UserType]: any;
    readonly id: UserId;
    readonly name: UserName;
    readonly email: UserEmail;
    readonly role: UserAccountRole;

    private constructor(
        id: UserId,
        name: UserName,
        email: UserEmail,
        role: UserAccountRole
    ) {
        this.id = id;
        this.name = name;
        this.email = email;
        this.role = role;
    }

    static from(
        id: UserId,
        name: UserName,
        email: UserEmail,
        role: UserAccountRole
    ): User {
        return new User(id, name, email, role);
    }

    isAdmin(): boolean {
        return this.role === UserAccountRole.ADMINISTRATOR;
    }

    isClient(): boolean {
        return this.role === UserAccountRole.CLIENT;
    }

    isOperator(): boolean {
        return this.role === UserAccountRole.OPERATOR;
    }
}

export type UserListJson = {
    id: string,
    name: string,
    email: string,
    role: string
}[]

export type UserInformationJson = {
    id: string,
    name: string,
    email: string,
    role: string
}

export enum UserEditType {
    ADD = "登録",
    UPDATE = "更新",
}
